export default "<div class=\"progress\">\n    <div #bar class=\"bar\"></div>\n</div>"